import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Input from '@mui/material/Input';
import * as profileAPI from '../../actions/profile';
import * as appDisplay from '../../actions/appDisplay';
import FormWrapper from '../common/form/FormWrapper';
import Form from '../common/form/Form';
import FormField from '../common/form/FormField';
import PopMessage from '../common/messages/PopMessage';
import stateConfig from '../../config/state';
import urls from '../../config/urls';
import validator from '../../utils/validator';

function MemberRegistration({ updates, profileAPI }) {
  const navigate = useNavigate();

  const [submission, setSubmission] = useState(false);
  const [fields, setFields] = useState({
    email: '',
    salutation: '',
    firstName: '',
    lastName: ''
  });
  const [errors, setErrors] = useState({});
  const [registrationError, setRegistrationError] = useState(null);
  const { email } = fields;

  useEffect(() => {
    const update = updates.byId[`${stateConfig.keys.PROFILE_UPDATES}.${email}`];

    if(submission && updates.ids && update) {
      if(update.error) {
        setSubmission(false);
        setRegistrationError(update.error);
      } else {
        navigate(`${urls.memberManage}?email=${email}&newMember=true`);
      }
    }
  }, [updates, email, navigate, submission, fields]); 

const onFieldChange = (event) => {
    const { name, value } = event.target;
    setFields(prev => ({...prev, [name]: value}));
  };

const validate = () => {
  const rules = [
    { rule: validator.rules.MATCHES_PATTERN, prop: 'email', against: validator.patterns.EMAIL, empty: true },
    { rule: validator.rules.IS_DEFINED, prop: 'email' },
    { rule: validator.rules.MATCHES_PATTERN, prop: 'salutation', against: validator.patterns.SALUTATION, empty: true },
    { rule: validator.rules.MATCHES_PATTERN, prop: 'firstName', against: validator.patterns.NAME, empty: true },
    { rule: validator.rules.MATCHES_PATTERN, prop: 'lastName', against: validator.patterns.NAME, empty: true }
  ];
  
  const validationErrors = validator.validate(fields, rules);
  if(validationErrors) {
    setErrors(validationErrors);
    return false;
  }

  return true;
}

const onSubmit = (event) => {
  event.preventDefault();

  if(!validate()) return;  
  setSubmission(true);
  setErrors({});
  profileAPI.registerMember(fields);
};

const clearPopMessage = () => {
  setRegistrationError(null);
};

  return (
    <div className="MemberRegistration">
      <FormWrapper squared={true} raised={true}>
        <h2>Register Member</h2>
        <Form id='MemberRegistration-form' onSubmit={onSubmit} submitLabel="Register" 
          submission={submission} autoComplete="off">

            <FormField fieldName="email" label="Email*"
              error={validator.message(errors['email'], 'email')}>
              <Input name="email" placeholder='Email' value={fields.email}
                onChange={onFieldChange} error={validator.isDefined(errors['email'])} />
            </FormField>

            <FormField fieldName="salutation" label="Salutation" 
              error={validator.message(errors['salutation'], 'salutation')}>
              <Input name="salutation" placeholder='Salutation' value={fields.salutation} 
                onChange={onFieldChange} error={validator.isDefined(errors['salutation'])} />
            </FormField>

            <FormField fieldName="firstName" label="First Name" 
              error={validator.message(errors['firstName'], 'first name')}>
              <Input name="firstName" placeholder='First Name' value={fields.firstName}
                onChange={onFieldChange} error={validator.isDefined(errors['firstName'])} />
            </FormField>
            
            <FormField fieldName="lastName" label="Last Name" 
              error={validator.message(errors['lastName'], 'last name')}>
              <Input name="lastName" placeholder='Last Name' value={fields.lastName}
                onChange={onFieldChange} error={validator.isDefined(errors['lastName'])} />
            </FormField>

        </Form>
      </FormWrapper>
      { registrationError !== null &&
        <PopMessage horizontal="center" open={true} onClose={clearPopMessage}
          type={stateConfig.messageTypes.ERROR}>
          <p>This registration failed: {registrationError.code} - {registrationError.message}</p>
        </PopMessage>
      }
    </div>
  );
}


function mapStateToProps(state) {
  return {
    updates: state.profileUpdates
  };
}

function mapDispatchToProps(dispatch) {
  return { 
    profileAPI: bindActionCreators(profileAPI, dispatch),
    appDisplay: bindActionCreators(appDisplay, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MemberRegistration);